/**
 * @file 组件初始化入口
 */

import TTree from './tree.vue'

TTree.install = Vue => {
  Vue.component(TTree.name, TTree)
}

export {
  TTree
}



// WEBPACK FOOTER //
// ./src/module/tree/index.js